// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"notifications__gradient-bg5__xvjnk","notifications":"notifications__notifications__Gp1_M","notification":"notifications__notification__DBEzh"};